module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3YhA9"))).then(() => parcelRequire('1iHdE'));